export default "__VITE_ASSET__Bjjmz9OH__"